// extracted by mini-css-extract-plugin
export var backdropBlur = "_mn-0";
export var contentCard = "_mn-5";
export var frame = "_mn-2";
export var image = "_mn-4";
export var imagePane = "_mn-3";
export var modal = "_mn-1";